import { render, staticRenderFns } from "./verify-email-form.html?vue&type=template&id=fb74c2e8&scoped=true&"
import script from "./verify-email-form.js?vue&type=script&lang=js&"
export * from "./verify-email-form.js?vue&type=script&lang=js&"
import style0 from "./VerifyEmailForm.vue?vue&type=style&index=0&id=fb74c2e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb74c2e8",
  null
  
)

component.options.__file = "VerifyEmailForm.vue"
export default component.exports